// Legacy stub kept only so the /admin page (now deprecated) still mounts.
// Blogs are stored as Markdown files in /public/blogs/. See public/blogs/README.md.
export const blogPosts = [];
